// Phase 5 consolidated mocks: CRM, Analytics, Admin, Sequence Templates
const FIRST = ["Sarah", "Marcus", "Maya", "Diego", "Priya", "Linh", "Alex", "Naomi", "Jonas", "Helen", "Sebastián", "Anya", "Rafael", "Mei", "Tomás", "Olivia", "Pierre", "Ingrid", "Daniel", "Yara", "Lukas", "Ana", "Karim", "Sofia", "Marcus"];
const LAST = ["Chen", "Okafor", "Bauer", "Ramírez", "Whitford", "Tran", "Park", "Castillo", "Berg", "Kim", "Iversen", "Dubois", "Beltrán", "Halliday", "Petrov", "Johansson", "Nakamura", "Costa", "Singh", "Almeida"];
const COMPANIES = ["Stripe", "Linear", "Notion", "Vercel", "Datadog", "Ramp", "Anthropic", "OpenAI", "Figma", "Asana", "Loom", "Webflow", "Retool", "Snyk", "Sentry", "Twilio", "Plaid", "Brex", "Mercury", "Mux", "Posthog", "Render", "Replit", "Cursor", "Modal", "Hex", "Linear", "Pinecone", "LangChain", "ElevenLabs"];
const TITLES = ["VP Sales", "RevOps Director", "SDR Manager", "Founder/CEO", "CMO", "Head of Marketing", "Head of CS", "AE", "Enterprise AE", "SDR", "Sales Engineer", "BDR"];
const INDUSTRIES = ["SaaS", "Fintech", "Dev Tools", "AI/ML", "Healthcare", "E-commerce", "Edtech", "Cybersecurity"];
const SOURCES = ["Reddit signal", "LinkedIn signal", "Inbound demo form", "Cold sequence", "Webinar", "Referral", "Quora signal", "G2 review", "Partner intro"];
const LEAD_STATUS = ["New", "Contacted", "Qualified", "Disqualified"];
const OWNERS = ["Maya Okafor", "Sarah Chen", "Marcus Bauer", "Diego Ramírez", "Priya R."];
const TAGS_POOL = ["high-intent", "enterprise", "mid-market", "champion", "stalled", "decision-maker", "competitor-switch", "expansion"];
const TECH_STACKS = [["Salesforce", "HubSpot", "Outreach"], ["HubSpot", "Apollo", "Gong"], ["Pipedrive", "Calendly"], ["Custom CRM", "Notion", "Linear"], ["Salesforce", "Marketo", "ZoomInfo"]];
const COMPETITORS = ["Salesforce", "Outreach", "Apollo", "HubSpot", "Front", "Intercom"];
const DEAL_STAGES = ["Discovery", "Demo", "Proposal", "Negotiation", "Closed Won", "Closed Lost"];

const rnd = (i, arr) => arr[i % arr.length];
const fullName = (i) => `${rnd(i, FIRST)} ${rnd(i * 3 + 1, LAST)}`;

export const crmLeads = Array.from({ length: 150 }).map((_, i) => ({
  id: `lead-${i + 1}`,
  name: fullName(i),
  company: rnd(i, COMPANIES),
  title: rnd(i, TITLES),
  email: `${rnd(i, FIRST).toLowerCase()}@${rnd(i, COMPANIES).toLowerCase()}.com`,
  phone: `+1 555 ${String(100 + (i * 73) % 900).padStart(3, "0")} ${String(1000 + (i * 31) % 9000).padStart(4, "0")}`,
  source: rnd(i, SOURCES),
  sourceId: i % 4 === 0 ? `sig-${(i % 80) + 1}` : null,
  status: rnd(i, LEAD_STATUS),
  score: 30 + ((i * 11) % 70),
  owner: rnd(i, OWNERS),
  created: `${(i % 60) + 1}d ago`,
  lastActivity: `${(i % 30) + 1}h ago`,
  tags: TAGS_POOL.filter((_, k) => (i + k) % 3 === 0).slice(0, 2),
}));

export const crmAccounts = Array.from({ length: 80 }).map((_, i) => ({
  id: `acc-${i + 1}`,
  name: rnd(i, COMPANIES) + (i >= COMPANIES.length ? ` ${Math.floor(i / COMPANIES.length) + 1}` : ""),
  industry: rnd(i, INDUSTRIES),
  employees: [50, 120, 250, 480, 980, 1850, 3400][i % 7],
  revenue: ["$2M", "$8M", "$22M", "$58M", "$140M", "$420M", "$1.2B"][i % 7],
  hq: ["San Francisco", "New York", "Berlin", "London", "Singapore", "Paris", "Toronto"][i % 7],
  website: `${rnd(i, COMPANIES).toLowerCase()}.com`,
  openDealsValue: 12000 + (i * 4800) % 480000,
  contactsCount: 3 + (i % 18),
  health: ["Green", "Green", "Yellow", "Red"][i % 4],
  owner: rnd(i, OWNERS),
  techStack: TECH_STACKS[i % TECH_STACKS.length],
  created: `${(i * 7) % 365}d ago`,
}));

export const crmContacts = Array.from({ length: 250 }).map((_, i) => ({
  id: `cnt-${i + 1}`,
  name: fullName(i + 7),
  title: rnd(i, TITLES),
  accountId: `acc-${(i % 80) + 1}`,
  company: crmAccounts[i % 80].name,
  email: `${rnd(i + 3, FIRST).toLowerCase()}@${crmAccounts[i % 80].name.toLowerCase().replace(/\s/g, "")}.com`,
  phone: `+1 555 ${String(200 + (i * 53) % 800).padStart(3, "0")}`,
  owner: rnd(i, OWNERS),
  lastContacted: `${(i % 45) + 1}d ago`,
  engagement: 20 + (i * 7) % 80,
  relationship: ["Strong", "Warm", "New", "Cooling"][i % 4],
  tags: TAGS_POOL.filter((_, k) => (i + k) % 4 === 0).slice(0, 2),
}));

export const crmOpportunities = Array.from({ length: 60 }).map((_, i) => {
  const stage = DEAL_STAGES[i % 6];
  const account = crmAccounts[i % 80];
  return {
    id: `opp-${i + 1}`,
    name: `${account.name} — ${["Enterprise", "Growth", "Pilot", "Expansion", "Renewal"][i % 5]}`,
    accountId: account.id,
    accountName: account.name,
    value: 15000 + (i * 4800) % 240000,
    stage,
    stageAge: `${(i % 28) + 1}d`,
    owner: rnd(i, OWNERS),
    probability: { Discovery: 15, Demo: 30, Proposal: 55, Negotiation: 75, "Closed Won": 100, "Closed Lost": 0 }[stage],
    closeDate: `${["Mar", "Apr", "May", "Jun"][i % 4]} ${(i % 28) + 1}, 2026`,
    nextStep: ["Send pricing", "Schedule demo", "Legal review", "Champion call", "Procurement"][i % 5],
    competitors: COMPETITORS.filter((_, k) => (i + k) % 3 === 0).slice(0, 2),
  };
});

export const crmActivities = Array.from({ length: 50 }).map((_, i) => ({
  id: `act-${i + 1}`,
  type: ["call", "email", "meeting", "task", "signal", "ai-action"][i % 6],
  title: ["Discovery call", "Follow-up email", "Demo scheduled", "Send proposal", "Signal detected", "Agent drafted reply"][i % 6],
  who: rnd(i, OWNERS),
  ref: i % 2 === 0 ? `lead-${(i % 150) + 1}` : `opp-${(i % 60) + 1}`,
  when: ["Today 10:00 AM", "Today 2:00 PM", "Tomorrow 9:00 AM", "Wed 3:00 PM"][i % 4],
  priority: ["high", "medium", "low"][i % 3],
  done: i % 4 === 3,
}));

export const aiNextBestActions = [
  { id: "nba1", title: "Send pricing one-pager", reason: "Last email mentioned cost concern. Champion is researching alternatives.", confidence: 92 },
  { id: "nba2", title: "Schedule discovery call this week", reason: "Engagement spiking — 4 site visits in 72h, downloaded 2 case studies.", confidence: 87 },
  { id: "nba3", title: "Loop in technical buyer (CTO)", reason: "MEDDIC gap — no technical champion identified. Found CTO Marcus Iversen via LinkedIn.", confidence: 78 },
];

export const aiDealCoach = [
  { id: "dc1", severity: "warn", title: "MEDDIC gap detected — no Economic Buyer mapped", action: "Map decision unit. Suggested: CFO Helen Castillo (LinkedIn match)." },
  { id: "dc2", severity: "risk", title: "Champion went silent 18 days", action: "Re-engage with the Ramp case study. Open rate prediction: 71%." },
  { id: "dc3", severity: "opportunity", title: "Similar deal closed with 12% discount on day 30", action: "Consider proposal with auto-discount now. Likelihood +18%." },
];

export const aiAccountBrief = `Acme Co (180 employees, $42M ARR) is a fast-growing SaaS platform expanding into AI sales automation. Currently using Salesforce + Outreach, but recent LinkedIn signals (3 in last 14 days) indicate active evaluation of modern alternatives.

Key buying committee:
• Naomi Park — CRO (champion, engaged 4x in last 30 days)
• Marcus Iversen — CTO (technical evaluator, attended demo)
• Helen Castillo — CFO (economic buyer, not yet engaged — risk)

Best path: Loop Helen Castillo into the next demo. Cost-focused messaging that contrasts seat-based vs usage-based pricing tends to land well with finance ICPs at this revenue band.`;

// ===== ANALYTICS =====
const days = Array.from({ length: 30 }).map((_, i) => ({ d: `D${i + 1}`, revenue: 24000 + Math.sin(i / 3) * 8000 + i * 600, pipeline: 38000 + Math.cos(i / 4) * 12000 + i * 700, won: 8000 + Math.sin(i / 5) * 3000 + i * 200 }));

export const execKpis = [
  { k: "Revenue", v: "$1,284,500", delta: 18.4 },
  { k: "New Pipeline", v: "$3,182,000", delta: 22.1 },
  { k: "Closed Won", v: "$682,400", delta: 11.7 },
  { k: "Win Rate", v: "31.4%", delta: 3.2 },
  { k: "Avg Sales Cycle", v: "47d", delta: -4.1 },
  { k: "CAC", v: "$1,840", delta: -8.2 },
  { k: "LTV", v: "$48,200", delta: 6.4 },
  { k: "Pipeline Coverage", v: "4.2×", delta: 0.8 },
];

export const revenueTimeSeries = days;
export const forecastVsActual = days.map((d, i) => ({ ...d, forecast: d.revenue * (0.95 + (i % 5) * 0.02), actualLow: d.revenue * 0.9, actualHigh: d.revenue * 1.1 }));

export const channelAnalytics = [
  { ch: "WhatsApp", inboundVol: 1842, outboundVol: 184, responseRate: 64, conv: 21, ttr: "32s" },
  { ch: "Email", inboundVol: 1240, outboundVol: 1842, responseRate: 18, conv: 14, ttr: "12m" },
  { ch: "SMS", inboundVol: 412, outboundVol: 96, responseRate: 28, conv: 11, ttr: "42s" },
  { ch: "Web Chat", inboundVol: 982, outboundVol: 0, responseRate: 71, conv: 24, ttr: "18s" },
  { ch: "Voice", inboundVol: 184, outboundVol: 84, responseRate: 38, conv: 32, ttr: "8m" },
  { ch: "Telegram", inboundVol: 64, outboundVol: 22, responseRate: 41, conv: 14, ttr: "1m" },
  { ch: "LinkedIn", inboundVol: 142, outboundVol: 412, responseRate: 22, conv: 18, ttr: "2h" },
];

const agentNames = ["Maya", "Maya", "Maya", "Maya", "Maya", "Maya", "Maya", "Maya", "Maya", "Maya", "Maya", "Maya"];
export const agentRoi = agentNames.map((name, i) => ({
  id: `ag-${name.toLowerCase()}`,
  name,
  role: ["Inbound triage", "Sales SDR", "Voice receptionist", "Quora answerer", "Reddit responder", "Email drafter"][i % 6],
  convos: 412 + (i * 84) % 2400,
  resolutionRate: 72 + (i * 3) % 24,
  escalationRate: 8 + (i * 2) % 18,
  aht: `${28 + (i * 3) % 90}s`,
  sentiment: 0.62 + ((i * 7) % 30) / 100,
  costPerResolved: 0.18 + (i * 0.04) % 1.2,
  revenueAttributed: 12000 + (i * 4800) % 280000,
  deflection: 64 + (i * 2) % 30,
  csat: 4.3 + ((i * 4) % 14) / 10,
  roi: 4.2 + (i * 0.8) % 14,
  spark: Array.from({ length: 14 }).map((_, j) => 40 + Math.sin((i + j) / 2) * 18 + j * 2),
  tokenSpend: 184 + i * 42,
  vsHuman: { hoursSaved: 240 + i * 18, costSaved: 8200 + i * 480, revenueShare: 32 + (i * 2) % 24 },
}));

export const aiVsHumanCards = {
  deflected: 4842,
  sdrTimeSaved: "1,184h",
  revenueAttributed: "$842,200",
  hoursReplaced: "5.2 FTE",
};

export const campaignAnalytics = Array.from({ length: 12 }).map((_, i) => ({
  id: `cmp-${i + 1}`,
  name: ["Cold Outreach Q4", "Series-B Funded SaaS", "Salesforce Switchers", "WhatsApp Pilot", "RevOps Persona", "Founders Direct", "Q1 Demo Push", "Win-back Campaign", "Mid-market Expansion", "Webinar Follow-ups", "G2 Reviewers", "Stalled Re-engage"][i],
  sent: 1200 + i * 280,
  openRate: 38 + (i * 2) % 32,
  replyRate: 8 + (i * 1.4) % 18,
  meetings: 12 + (i * 3) % 48,
  opps: 4 + i % 14,
  pipeline: 28000 + i * 18400,
  closedWon: 4200 + i * 8400,
  cac: 1200 + (i * 84) % 2400,
  roi: 2.4 + (i * 0.6) % 8,
}));

export const funnelData = [
  { stage: "Visitors", count: 124000, conv: null },
  { stage: "Signals", count: 18400, conv: 14.8 },
  { stage: "Leads", count: 6240, conv: 33.9 },
  { stage: "MQLs", count: 2840, conv: 45.5 },
  { stage: "SQLs", count: 1248, conv: 43.9 },
  { stage: "Opportunities", count: 412, conv: 33.0 },
  { stage: "Proposal", count: 184, conv: 44.7 },
  { stage: "Closed Won", count: 82, conv: 44.5 },
];

export const revenueAttribution = [
  { source: "Signals", first: 248000, last: 184000, linear: 220000, decay: 240000 },
  { source: "Sequences", first: 184000, last: 348000, linear: 268000, decay: 290000 },
  { source: "Inbound", first: 412000, last: 248000, linear: 330000, decay: 280000 },
  { source: "Referrals", first: 88000, last: 124000, linear: 106000, decay: 120000 },
  { source: "Events", first: 64000, last: 42000, linear: 53000, decay: 48000 },
];

// ===== ADMIN =====
export const adminUsers = Array.from({ length: 25 }).map((_, i) => ({
  id: `usr-${i + 1}`,
  name: fullName(i + 11),
  email: `${rnd(i + 5, FIRST).toLowerCase()}@acme.com`,
  roles: [["Owner"], ["Admin"], ["Manager", "SDR"], ["SDR"], ["Marketer"], ["Viewer"]][i % 6],
  workspaces: ["Acme US", "Acme EU", "Acme APAC"].slice(0, (i % 3) + 1),
  status: ["Active", "Active", "Active", "Active", "Invited", "Suspended"][i % 6],
  lastLogin: ["2h ago", "5h ago", "1d ago", "3d ago", "—", "12d ago"][i % 6],
  mfa: i % 3 !== 0,
  created: `${(i * 9) % 365}d ago`,
}));

const featureRows = ["CRM Leads", "CRM Accounts", "CRM Deals", "Outbound Campaigns", "Agents", "Knowledge Base", "Content", "Signals", "Analytics", "Admin", "Billing"];
const permCols = ["View", "Create", "Edit", "Delete", "Admin"];
const buildMatrix = (defaults) => featureRows.map((f, i) => ({
  feature: f,
  perms: permCols.map((p, j) => defaults[f]?.includes(p) ?? false),
}));

export const adminRoles = [
  { id: "role-owner", name: "Owner", users: 1, description: "Full control of the workspace and billing", matrix: featureRows.map(f => ({ feature: f, perms: [true, true, true, true, true] })) },
  { id: "role-admin", name: "Admin", users: 3, description: "Manage users, settings, integrations", matrix: featureRows.map(f => ({ feature: f, perms: [true, true, true, true, f !== "Billing"] })) },
  { id: "role-mgr", name: "Manager", users: 5, description: "Manage SDRs and pipelines", matrix: featureRows.map(f => ({ feature: f, perms: [true, true, true, ["CRM Leads", "Outbound Campaigns", "Content"].includes(f), false] })) },
  { id: "role-sdr", name: "SDR", users: 12, description: "Reach prospects, manage assigned leads", matrix: featureRows.map(f => ({ feature: f, perms: [["CRM Leads", "CRM Accounts", "CRM Deals", "Outbound Campaigns", "Agents", "Content", "Signals"].includes(f), ["CRM Leads", "Outbound Campaigns", "Content"].includes(f), ["CRM Leads", "Outbound Campaigns"].includes(f), false, false] })) },
  { id: "role-mkt", name: "Marketer", users: 4, description: "Content + Analytics access", matrix: featureRows.map(f => ({ feature: f, perms: [["Content", "Analytics", "Signals", "Knowledge Base"].includes(f), ["Content", "Knowledge Base"].includes(f), ["Content"].includes(f), false, false] })) },
  { id: "role-view", name: "Viewer", users: 6, description: "Read-only access", matrix: featureRows.map(f => ({ feature: f, perms: [f !== "Admin" && f !== "Billing", false, false, false, false] })) },
];
export const permissionRows = featureRows;
export const permissionCols = permCols;

export const adminTenants = [
  { id: "t-acme", name: "Acme Corp", domain: "acme.com", owner: "Maya Okafor", users: 18, plan: "Scale", status: "Active", created: "12mo ago" },
  { id: "t-acme-eu", name: "Acme EU", domain: "acme.eu", owner: "Pierre Dubois", users: 8, plan: "Growth", status: "Active", created: "8mo ago" },
  { id: "t-acme-apac", name: "Acme APAC", domain: "acme.sg", owner: "Linh Tran", users: 4, plan: "Growth", status: "Active", created: "4mo ago" },
  { id: "t-partner", name: "Sellyx Partner Sandbox", domain: "partner.sellix.io", owner: "Sarah Chen", users: 2, plan: "Starter", status: "Trial", created: "14d ago" },
  { id: "t-demo", name: "Demo Workspace", domain: "demo.acme.com", owner: "Maya Okafor", users: 6, plan: "Enterprise", status: "Active", created: "18mo ago" },
];

export const adminIntegrations = [
  { id: "openclaw", name: "OpenClaw Gateway", desc: "Agent runtime, sessions, tool calling, memory", status: "Connected", lastSync: "12s ago", icon: "OC", special: true, version: "v3.2.1", uptime: "99.98%", runtimes: ["openclaw", "claude-cli", "codex", "copilot"], channels: 14, latency: "82ms" },
  { id: "zoho", name: "Zoho CRM", desc: "Imported deals (read-only mirror · two-way in V2.5)", status: "Connected", lastSync: "5m ago", icon: "Z" },
  { id: "sharepoint", name: "SharePoint", desc: "Knowledge base sync", status: "Connected", lastSync: "1h ago", icon: "S" },
  { id: "gw", name: "Google Workspace", desc: "Gmail + Calendar + Drive", status: "Connected", lastSync: "12m ago", icon: "G" },
  { id: "ms365", name: "Microsoft 365", desc: "Outlook + Teams + OneDrive", status: "Connected", lastSync: "22m ago", icon: "M" },
  { id: "slack", name: "Slack", desc: "Alerts + commands", status: "Connected", lastSync: "8m ago", icon: "#" },
  { id: "teams", name: "MS Teams", desc: "Notifications + chat", status: "Disconnected", lastSync: "—", icon: "T" },
  { id: "hubspot", name: "HubSpot", desc: "Imported deals (read-only mirror · two-way in V2.5)", status: "Disconnected", lastSync: "—", icon: "H" },
  { id: "sfdc", name: "Salesforce", desc: "Imported deals (read-only mirror · two-way in V2.5)", status: "Error", lastSync: "2h ago", icon: "SF" },
  { id: "notion", name: "Notion", desc: "Docs as knowledge", status: "Connected", lastSync: "1d ago", icon: "N" },
  { id: "stripe", name: "Stripe", desc: "Billing + revenue", status: "Connected", lastSync: "32m ago", icon: "$" },
  { id: "twilio", name: "Twilio", desc: "SMS + Voice", status: "Connected", lastSync: "1m ago", icon: "Tw" },
  { id: "11labs", name: "ElevenLabs", desc: "Voice synthesis", status: "Connected", lastSync: "4m ago", icon: "11" },
];

export const adminBilling = {
  plan: "Scale",
  monthly: 2400,
  yearly: 24000,
  features: ["Unlimited agents", "Unlimited channels", "25 users", "5M conversations / month", "100GB knowledge base"],
  quotas: [
    { label: "Conversations", used: 2842184, limit: 5000000 },
    { label: "Agents", used: 12, limit: 50 },
    { label: "Users", used: 18, limit: 25 },
    { label: "KB documents", used: 752, limit: 5000 },
    { label: "API requests", used: 1842000, limit: 5000000 },
  ],
  invoices: Array.from({ length: 12 }).map((_, i) => ({
    id: `INV-2026-${String(i + 1).padStart(3, "0")}`,
    date: `${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][i]} 1, 2026`,
    amount: 2400 + (i === 0 ? 480 : 0),
    status: i === 2 ? "Pending" : "Paid",
  })),
  payment: { card: "•••• 4242", expires: "08/29", billing: "1 Market St, San Francisco CA", tax: "US 84-2839184" },
};

export const adminAudit = Array.from({ length: 80 }).map((_, i) => ({
  id: `aud-${i + 1}`,
  ts: `2026-02-${String((i % 28) + 1).padStart(2, "0")} ${String((i * 3) % 24).padStart(2, "0")}:${String((i * 7) % 60).padStart(2, "0")}`,
  user: rnd(i, OWNERS),
  action: ["user.invited", "user.suspended", "role.updated", "integration.connected", "kb.uploaded", "agent.deployed", "agent.paused", "deal.created", "deal.won", "rule.activated", "settings.changed", "billing.updated"][i % 12],
  entity: ["users", "users", "roles", "integrations", "kb", "agents", "agents", "deals", "deals", "rules", "settings", "billing"][i % 12],
  ip: `74.${(i * 7) % 255}.${(i * 11) % 255}.${(i * 13) % 255}`,
  ua: ["Chrome 122 on macOS", "Safari 17 on iOS", "Firefox 121 on Windows", "API token"][i % 4],
  severity: ["info", "info", "info", "warn", "info", "info", "warn", "info", "info", "info", "warn", "info"][i % 12],
}));

// ===== SEQUENCE TEMPLATES (for AI Suggest) =====
export const sequenceTemplates = [
  {
    id: "tmpl-1",
    name: "VP Sales · Book Demo · 5 steps",
    forPersona: "VP Sales", goal: "Book demo", channels: ["linkedin", "email", "voice"], length: 5, tone: "Direct",
    steps: [
      { type: "linkedin", label: "LinkedIn Connect", config: { note: "Hi {{first_name}} — saw your post on outbound. Would love to share what's working at Ramp." } },
      { type: "wait", label: "Wait 2 days", config: { days: 2 } },
      { type: "linkedin", label: "Personalized Message", config: { body: "If LinkedIn accepted — share specific framework, no pitch." } },
      { type: "email", label: "Value Email", config: { subject: "{{first_name}} — quick GTM benchmark for {{company}}", body: "Direct value email with industry benchmark." } },
      { type: "voice", label: "AI Voice Call", config: { script: "Hi {{first_name}}, this is Riley calling about the email we sent — 1-minute pitch." } },
    ],
  },
  {
    id: "tmpl-2",
    name: "Founder · Re-engage · 4 steps",
    forPersona: "Founder/CEO", goal: "Re-engage", channels: ["email", "linkedin"], length: 4, tone: "Friendly",
    steps: [
      { type: "email", label: "Pattern-interrupt Email", config: { subject: "Quick one — still building?", body: "Re-engage with case-study reference." } },
      { type: "wait", label: "Wait 3 days", config: { days: 3 } },
      { type: "linkedin", label: "LinkedIn DM", config: { body: "Founder-to-founder DM with one specific question." } },
      { type: "email", label: "Breakup Email", config: { subject: "Should I close your file?", body: "Polite breakup with door open." } },
    ],
  },
  {
    id: "tmpl-3",
    name: "RevOps Director · Free Trial · 6 steps",
    forPersona: "RevOps Director", goal: "Free trial", channels: ["email", "linkedin", "voice"], length: 6, tone: "Analytical",
    steps: [
      { type: "linkedin", label: "Connect with context", config: { note: "Hi {{first_name}} — Ramp's RevOps lead loved Sellyx. Open to compare notes?" } },
      { type: "wait", label: "Wait 1 day", config: { days: 1 } },
      { type: "email", label: "Benchmark Email", config: { subject: "RevOps benchmarks Q4 2025 — your peers", body: "Data-driven pitch with peer benchmark." } },
      { type: "wait", label: "Wait 4 days", config: { days: 4 } },
      { type: "email", label: "Free Trial CTA", config: { subject: "14-day pilot — no calls required", body: "Self-serve trial CTA, no sales-y language." } },
      { type: "voice", label: "AI Voice Follow-up", config: { script: "Short check-in voice call." } },
    ],
  },
  {
    id: "tmpl-4",
    name: "SDR Manager · Event Invite · 3 steps",
    forPersona: "SDR Manager", goal: "Event invite", channels: ["linkedin", "email"], length: 3, tone: "Confident",
    steps: [
      { type: "email", label: "Webinar Invite", config: { subject: "{{first_name}} — 20-min on AI SDR economics", body: "Direct webinar invite with calendar link." } },
      { type: "linkedin", label: "Personal Reminder", config: { note: "Saw you didn't RSVP — replay link inside if live doesn't work." } },
      { type: "email", label: "Day-of Reminder", config: { subject: "Starting in 1 hour", body: "Day-of reminder." } },
    ],
  },
];
